/**
 * Converts a UTC ISO string to a value suitable for a datetime-local input,
 * expressed in the given IANA timezone.
 */
export function utcToLocalInput(utcIso: string | null | undefined, tz: string): string {
    if (!utcIso) return ''
    return new Date(utcIso)
        .toLocaleString('sv-SE', {timeZone: tz})
        .replace(' ', 'T')
        .slice(0, 16)
}

/**
 * Converts a UTC ISO string to a date string (YYYY-MM-DD) in the given timezone.
 */
export function utcToDateInput(utcIso: string | null | undefined, tz: string): string {
    if (!utcIso) return ''
    return new Date(utcIso)
        .toLocaleString('sv-SE', {timeZone: tz})
        .slice(0, 10)
}

/**
 * Converts a UTC ISO string to a time string (HH:mm) in the given timezone.
 */
export function utcToTimeInput(utcIso: string | null | undefined, tz: string): string {
    if (!utcIso) return ''
    return new Date(utcIso)
        .toLocaleString('sv-SE', {timeZone: tz})
        .slice(11, 16)
}

/**
 * Converts a datetime-local input value (YYYY-MM-DDTHH:mm) entered in the
 * given IANA timezone to a UTC ISO string.
 */
export function localInputToUtc(localValue: string, tz: string): string {
    if (!localValue) return ''
    const fakeUtcMs = new Date(localValue + ':00Z').getTime()
    const inTz = new Date(fakeUtcMs)
        .toLocaleString('sv-SE', {timeZone: tz})
        .replace(' ', 'T')
        .slice(0, 16)
    const inTzMs = new Date(inTz + ':00Z').getTime()
    return new Date(2 * fakeUtcMs - inTzMs).toISOString()
}

/**
 * Combines separate date (YYYY-MM-DD) and time (HH:mm) inputs entered in
 * the given timezone and returns a UTC ISO string, or null if no date given.
 */
export function localDateTimeToUtc(date: string, time: string, tz: string): string | null {
    if (!date) return null
    return localInputToUtc(`${date}T${time || '00:00'}`, tz)
}
